module.exports = __webpack_public_path__ + "static/media/homebanner.345c6096.png";